module.exports = __webpack_public_path__ + "img/69.f3a6536e.jpg";